import { Form, Button, Row, Col } from "antd";
import { Image as ImageIcon, Trash2 } from "lucide-react";
import MediaUpload from "Components/MediaUpload/MediaUpload";

function Step5Media({ form }) {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold">Event Media</h2>
      <p className="text-sm text-muted-foreground">
        Upload a primary banner image (4:5 portrait ratio required). Additional
        images are optional.
      </p>

      <Form.Item
        name="media_validator"
        noStyle
        rules={[
          {
            validator() {
              const items = (form.getFieldValue("media") ?? []).filter(Boolean);
              return items.length > 0
                ? Promise.resolve()
                : Promise.reject(new Error("Upload at least one image."));
            },
          },
        ]}
      >
        <input type="hidden" />
      </Form.Item>

      <Form.List name="media" initialValue={[""]}>
        {(fields, { add, remove }) => {
          const revalidate = () =>
            form.validateFields(["media_validator"]).catch(() => {});
          return (
            <div className="space-y-4">
              <div>
                {fields.map(({ key, name }) => (
                  <Row key={key} gutter={[16, 0]} align="middle">
                    <Col span={20}>
                      <Form.Item
                        name={name}
                        label={
                          name === 0 ? "Primary Banner" : `Image ${name + 1}`
                        }
                        className="mb-0"
                        rules={
                          name === 0
                            ? [
                                {
                                  required: true,
                                  message: "Primary banner is required",
                                },
                              ]
                            : []
                        }
                      >
                        <MediaUpload
                          onChange={() => setTimeout(revalidate, 0)}
                          maxSizeMB={5}
                          aspectRatio={{ width: 4, height: 5, enforce: true }}
                        />
                      </Form.Item>
                    </Col>
                    <Col>
                      {fields.length > 1 && (
                        <Button
                          type="text"
                          size="small"
                          danger
                          icon={<Trash2 className="h-4 w-4" />}
                          onClick={() => {
                            remove(name);
                            setTimeout(revalidate, 0);
                          }}
                        >
                          Remove
                        </Button>
                      )}
                    </Col>
                  </Row>
                ))}
              </div>
              {fields.length < 4 && (
                <Button
                  type="dashed"
                  block
                  onClick={() => {
                    add("");
                    setTimeout(revalidate, 0);
                  }}
                  icon={<ImageIcon className="h-4 w-4" />}
                >
                  Add Another Image
                </Button>
              )}
            </div>
          );
        }}
      </Form.List>
    </div>
  );
}

export default Step5Media;
